import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Page } from "components/shared/Page/Page";
import { ForgotPasswordFormm } from "components/user/ForgotPasswordForm/ForgotPassword";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  forgotPassword: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

interface Props {}

export const ForgotPassword = (props: RouteComponentProps<Props>) => {
  const classes = useStyles();
  return (
    <Page animate className={classes.forgotPassword}>
      <ForgotPasswordFormm />
    </Page>
  );
};
